import axios from 'axios';
import barba from '@barba/core';

export default class {

	constructor() {

		barba.hooks.afterOnce((data) => {
			this.init()
		});
		barba.hooks.after((data) => {
			this.init()
		});

	}

	init() {
		const InstaElem = document.getElementById('instafeed');
		if (InstaElem) {
			const template = '<div class="col-4"><div class="c-feed__card"><a href="{{link}}" target="_blank" class="c-feed__card--image" style="background-image:url(\'{{image}}\')"></a></div></div>';
			//const title = '<div class="col-lg-3 col-md-4 col-6 mb20"><div class="card instagram--title-wrap"><div class="instagram--title"><h3>INSTAGRAM<br>GALLERY</h3><div class="pt10"><a href="https://www.instagram.com/no3jp/?hl=ja" class="btn btn-double" target="_blank">@no3jp</a></div></div></div></div>';
			const limit = 9;

			// api設定項目
			const business_id = "17841409208800348";
			const access_token = "EAAKTm7U3uLEBO1vHOC7L7dqdDb7sz2Nrfi1GdqPtwSNXcu9kRlHhweLNUqeRkwPPxPxGbbdceniTC5Y6ZA105CzOVoM1QPnxmQ16ZAgmw5lhBJNN3GzGCZBNGrGuetlIXhy2sip1Ltq0ZBTq1yVI7WQz1MCDnD2purq5EAn7RmZBdhJoQcYjioMyu30KUZCjZAqWCSTSUkZD";

			// query
			const query = "name,media.limit(" + limit + "){caption,like_count,media_type,thumbnail_url,media_url,permalink,timestamp,username,comments_count}";

			const success = function () {
				var options = {
					pagination: '.instagram-wrap .swiper-pagination',
					nextButton: '.instagram-wrap .swiper-button-next',
					prevButton: '.instagram-wrap .swiper-button-prev',
					slidesPerView: 6,
					paginationClickable: true,
					spaceBetween: 0,
					grabCursor: true,
					// autoplay: 4000,
					loop: true,
					breakpoints: {
						991: {
							slidesPerView: 4,
							spaceBetweenSlides: 0
						},
						767: {
							slidesPerView: 3,
							spaceBetweenSlides: 5
						},
						400: {
							slidesPerView: 2,
							spaceBetweenSlides: 5
						}
					}
				};
				var swiper = undefined;
				//var winW = $(window).width();

				// function initSwiper() {
				//  	swiper = new Swiper('.instagram-wrap', options);
				// }
				// $('.instagram-wrap').imagesLoaded(function(){
				// 	initSwiper();
				// });
			}

			const replacements = ["link", "image", "caption", "likes", "comments"];
			const url = 'https://graph.facebook.com/v5.0/' + business_id + '?fields=' + query + '&access_token=' + access_token;

			axios.get(url)
				.then(function (res) {
                const datas = res.data.media.data.reverse()
                if (datas.length > 0) {
                    var str = "";
                    //var instaTitle = title;
                    for (var i = datas.length - 1; i >= 0; i--) {
                        const data = datas[i]
                        const newData = {
                            link: data.permalink,
                            image: (data.media_type == "VIDEO") ? data.thumbnail_url : data.media_url,
                            caption: data.caption,
                            likes: data.like_count,
                            comments: data.comments_count
                        }
                        var s = template;

                        for (var j = replacements.length - 1; j >= 0; j--) {
                            const replacement = replacements[j]
                            s = s.replace("{{" + replacement + "}}", newData[replacement]);
                        }
                        str += s;
                    }
                }
                InstaElem.innerHTML = str;
                success();
            })
            .catch(function (e) {
                //console.log(e)
            })
		}
	}
}
